import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { PartnersState } from './types'

const INITIAL_STATE: PartnersState = {
  error: '',
  list: [],
  loading: false,
  response: null,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendPartnerError: '',
  sendPartnerLoading: false,
  // ticketsEmission: [],
  total_results: 0
}

const reducer = createReducer<PartnersState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getPartners, state => ({
    ...state,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getPartnersFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getPartnersSuccess, (state, { payload }) => ({
    ...state,
    list: [...payload.partners],
    loading: false
  }))
  .handleAction(Actions.sendPartner, state => ({
    ...state,
    sendPartnerError: '',
    sendPartnerLoading: true
  }))
  .handleAction(Actions.sendPartnerFailure, (state, { payload }) => ({
    ...state,
    sendPartnerError: payload.message,
    sendPartnerLoading: false
  }))
  .handleAction(Actions.sendPartnerSuccess, (state, { payload }) => ({
    ...state,
    response: payload,
    sendPartnerLoading: false
  }))

export default reducer
